import routes from "./routes";
import store from "./store";

// FIXME: We should use default Vuex namespacing here instead of rolling our own.
export default { routes, modules: { dg_suite: store } };
